// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as FilterType from "../../../../../app/entity/FilterType.bs.js";
import * as Row$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as ProgressModal from "../../../../../../../../library/components/generic-components/components/ProgressModal.bs.js";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as SidebarHeaderCmp from "../reusable-components/SidebarHeaderCmp.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ManagePriorityFooter from "./ManagePriorityFooter.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as ZoneCLusterModalManager from "./ZoneCLusterModalManager.bs.js";
import * as AllocationDashboardUtils from "../../../utils/AllocationDashboardUtils.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as ModifyZoneClusterTabView from "./ModifyZoneClusterTabView.bs.js";
import * as ApprovedZoneClusterTabView from "./ApprovedZoneClusterTabView.bs.js";
import * as AllocationDashboardDataMachine from "../../../../../app/repo/AllocationDashboardDataMachine.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";
import * as AllocationDashboardStateMachine from "../../../AllocationDashboardStateMachine.bs.js";
import * as UpdateZoneClusterPayloadGenerator from "../../../utils/UpdateZoneClusterPayloadGenerator.bs.js";

function showWarningModal(modified_priorities, edited_modifications) {
  if (List.length(modified_priorities) !== 0) {
    return true;
  } else {
    return Object.keys(edited_modifications).length !== 0;
  }
}

var filterItems = {
  hd: {
    key: "AllocationRadius",
    value: "AllocationRadius",
    text: "Allocation Radius"
  },
  tl: {
    hd: {
      key: "DryRun",
      value: "DryRun",
      text: "Dry Run Ratio"
    },
    tl: {
      hd: {
        key: "MapsDistance",
        value: "MapsDistance",
        text: "Max Dry Run"
      },
      tl: /* [] */0
    }
  }
};

function getSelectedItem(value) {
  if (List.exists((function (a) {
            return a.value === value;
          }), filterItems)) {
    return List.find((function (item) {
                  return item.value === value;
                }), filterItems);
  } else {
    return Belt_List.getExn(filterItems, 0);
  }
}

function getFilteredCampaigns(zone_cluster_campaigns, filter) {
  return List.filter(function (campaign) {
                return campaign.sub_type === filter;
              })(zone_cluster_campaigns.campaigns);
}

function getCampaignCountByStatusForSelectedFilter(zone_cluster_campaign, selectedFilter, status) {
  return Belt_List.reduce(getFilteredCampaigns(zone_cluster_campaign, selectedFilter), 0, (function (acc, campaign) {
                return acc + (
                        campaign.status === status ? 1 : 0
                      ) | 0;
              }));
}

function getApprovedPriorities(zone_cluster_campaign, filter) {
  return List.filter(function (campaign) {
                return campaign.status !== /* PendingForReview */2;
              })(getFilteredCampaigns(zone_cluster_campaign, filter));
}

function ManagePrioritiesContainer(Props) {
  var mandatory_campaign = Props.mandatory_campaign;
  var vehicle = Props.vehicle;
  var geo_region = Props.geo_region;
  var zones = Props.zones;
  var clusters = Props.clusters;
  var zone_cluster_campaigns_list = Props.zone_cluster_campaigns_list;
  var dispatch = Props.dispatch;
  var user_role = Props.user_role;
  var setDirty = Props.setDirty;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return /* ApprovedPriorities */0;
      });
  var toggleTab = match$1[1];
  var activeTab = match$1[0];
  var match$2 = React.useState(function () {
        return Belt_List.getExn(filterItems, 0);
      });
  var updateSelectedFilter = match$2[1];
  var selectedFilter = match$2[0];
  var match$3 = ZoneCLusterModalManager.useModal(undefined);
  var open_modal = match$3[1];
  var match$4 = React.useState(function () {
        return /* All */0;
      });
  var updateUserAction = match$4[1];
  var allowedUserAction = match$4[0];
  var match$5 = React.useState(function () {
        return /* Init */0;
      });
  var setRequestStatus = match$5[1];
  var match$6 = React.useState(function () {
        
      });
  var updatePriority = match$6[1];
  var newPriority = match$6[0];
  var match$7 = React.useState(function () {
        
      });
  var setUpdatedStatus = match$7[1];
  var changedStatus = match$7[0];
  React.useEffect((function () {
          if (newPriority !== undefined) {
            if (changedStatus !== undefined) {
              ErrorUtils$Catalyst.raiseError("ManagePrioritiesContainer.res", "Change priority and update status cannot be done simultaniously", "");
            } else {
              Curry._1(updateUserAction, (function (param) {
                      return /* ChangePriority */1;
                    }));
            }
          } else if (changedStatus !== undefined) {
            Curry._1(updateUserAction, (function (param) {
                    return /* ChangeStatus */2;
                  }));
          } else {
            Curry._1(updateUserAction, (function (param) {
                    return /* All */0;
                  }));
          }
          
        }), [
        newPriority,
        changedStatus
      ]);
  React.useEffect((function () {
          if (allowedUserAction !== 0) {
            Curry._1(setDirty, (function (param) {
                    return true;
                  }));
          } else {
            Curry._1(updatePriority, (function (param) {
                    
                  }));
            Curry._1(setUpdatedStatus, (function (param) {
                    
                  }));
            Curry._1(updateUserAction, (function (param) {
                    return /* All */0;
                  }));
            Curry._1(setDirty, (function (param) {
                    return false;
                  }));
          }
          
        }), [allowedUserAction]);
  React.useEffect((function () {
          if (typeof zones === "number") {
            AllocationDashboardStateMachine.fetchZones(geo_region, dispatch, country);
          } else {
            switch (zones.TAG | 0) {
              case /* Loading */0 :
              case /* Live */1 :
                  break;
              case /* Error */2 :
                  Curry._1(dispatch, {
                        TAG: /* OpenSnackbar */7,
                        snackbar_message: {
                          TAG: /* Error */1,
                          _0: "Some error occoured while fetching zones"
                        }
                      });
                  break;
              
            }
          }
          if (typeof clusters === "number") {
            AllocationDashboardStateMachine.fetchClusters(geo_region, dispatch, country);
          } else {
            switch (clusters.TAG | 0) {
              case /* Loading */0 :
              case /* Live */1 :
                  break;
              case /* Error */2 :
                  Curry._1(dispatch, {
                        TAG: /* OpenSnackbar */7,
                        snackbar_message: {
                          TAG: /* Error */1,
                          _0: "Some error occoured while fetching clusters"
                        }
                      });
                  break;
              
            }
          }
          
        }), []);
  React.useEffect((function () {
          if (typeof zone_cluster_campaigns_list === "number") {
            AllocationDashboardStateMachine.fetchZonalClusterCampaign(vehicle, geo_region, dispatch, country);
          } else {
            switch (zone_cluster_campaigns_list.TAG | 0) {
              case /* Loading */0 :
              case /* Live */1 :
                  break;
              case /* Error */2 :
                  Curry._1(dispatch, {
                        TAG: /* OpenSnackbar */7,
                        snackbar_message: {
                          TAG: /* Error */1,
                          _0: "Some error occoured while fetching zone/cluster campaigns"
                        }
                      });
                  break;
              
            }
          }
          
        }), [zone_cluster_campaigns_list]);
  var tmp;
  if (typeof zone_cluster_campaigns_list === "number") {
    tmp = React.createElement(CircularLoader$Catalyst.make, {});
  } else {
    switch (zone_cluster_campaigns_list.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(CircularLoader$Catalyst.make, {});
          break;
      case /* Live */1 :
          var campaign = zone_cluster_campaigns_list._0;
          var tmp$1;
          if (activeTab) {
            var pendingCampaignCount = getCampaignCountByStatusForSelectedFilter(campaign, FilterType.fromString(selectedFilter.value), /* PendingForReview */2);
            tmp$1 = React.createElement(ModifyZoneClusterTabView.make, {
                  allowedUserAction: allowedUserAction,
                  filtered_campaigns: pendingCampaignCount !== 0 ? getFilteredCampaigns(campaign, FilterType.fromString(selectedFilter.value)) : /* [] */0,
                  mandatory_campaign: mandatory_campaign,
                  selected_geo_region: geo_region.name,
                  selected_vehicle: vehicle.vehicle.display_name,
                  updatePriority: updatePriority,
                  zones: zones,
                  clusters: clusters,
                  user_role: user_role,
                  open_modal: open_modal,
                  setUpdatedStatus: setUpdatedStatus,
                  dispatch: dispatch,
                  key: selectedFilter.value
                });
          } else {
            tmp$1 = React.createElement(ApprovedZoneClusterTabView.make, {
                  allowedUserAction: allowedUserAction,
                  mandatory_campaign: mandatory_campaign,
                  approved_campaigns: getApprovedPriorities(campaign, FilterType.fromString(selectedFilter.value)),
                  selected_geo_region: geo_region.name,
                  selected_vehicle: vehicle.vehicle.display_name,
                  zones: zones,
                  clusters: clusters,
                  user_role: user_role,
                  open_modal: open_modal,
                  setUpdatedStatus: setUpdatedStatus,
                  dispatch: dispatch
                });
          }
          tmp = React.createElement(React.Fragment, undefined, match$3[0], React.createElement("div", {
                    className: "c-manage-priority-container"
                  }, React.createElement("div", {
                        className: "filter-select"
                      }, React.createElement("label", undefined, "Select your preferred filter"), React.createElement(FormSelectInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                    if (allowedUserAction !== 0) {
                                      return Curry._1(dispatch, {
                                                  TAG: /* OpenModal */10,
                                                  modal: AllocationDashboardUtils.Modals.getDataLostWarningModalData((function (param) {
                                                          return Curry._1(dispatch, /* CloseModal */3);
                                                        }), (function (param) {
                                                          Curry._1(updateUserAction, (function (param) {
                                                                  return /* All */0;
                                                                }));
                                                          Curry._1(updateSelectedFilter, (function (param) {
                                                                  return getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                                                }));
                                                          return Curry._1(dispatch, /* CloseModal */3);
                                                        }))
                                                });
                                    } else {
                                      return Curry._1(updateSelectedFilter, (function (param) {
                                                    return getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                                  }));
                                    }
                                  }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            select_props: {
                              value: selectedFilter,
                              items: filterItems,
                              isNoneRequired: false
                            }
                          }), React.createElement("div", {
                            className: "ald-create-zonal-cluster-campaign-note-text"
                          }, "Note: Selecting the filter will reflect in the below priorities")), React.createElement(Row$Catalyst.make, {
                        children: React.createElement("div", {
                              className: "btn-wrapper"
                            }, React.createElement("div", {
                                  className: "core-pricing-btn " + (
                                    activeTab === /* ApprovedPriorities */0 ? "selected" : ""
                                  ),
                                  onClick: (function (param) {
                                      if (allowedUserAction !== 0) {
                                        return Curry._1(dispatch, {
                                                    TAG: /* OpenModal */10,
                                                    modal: AllocationDashboardUtils.Modals.getDataLostWarningModalData((function (param) {
                                                            return Curry._1(dispatch, /* CloseModal */3);
                                                          }), (function (param) {
                                                            Curry._1(updateUserAction, (function (param) {
                                                                    return /* All */0;
                                                                  }));
                                                            Curry._1(toggleTab, (function (param) {
                                                                    return /* ApprovedPriorities */0;
                                                                  }));
                                                            return Curry._1(dispatch, /* CloseModal */3);
                                                          }))
                                                  });
                                      } else {
                                        return Curry._1(toggleTab, (function (param) {
                                                      return /* ApprovedPriorities */0;
                                                    }));
                                      }
                                    })
                                }, "Approved Priorities"), React.createElement("div", {
                                  className: "modifications-btn " + (
                                    activeTab === /* PendingPriorities */1 ? "selected" : ""
                                  ),
                                  onClick: (function (param) {
                                      if (allowedUserAction !== 0) {
                                        return Curry._1(dispatch, {
                                                    TAG: /* OpenModal */10,
                                                    modal: AllocationDashboardUtils.Modals.getDataLostWarningModalData((function (param) {
                                                            return Curry._1(dispatch, /* CloseModal */3);
                                                          }), (function (param) {
                                                            Curry._1(updateUserAction, (function (param) {
                                                                    return /* All */0;
                                                                  }));
                                                            Curry._1(toggleTab, (function (param) {
                                                                    return /* PendingPriorities */1;
                                                                  }));
                                                            return Curry._1(dispatch, /* CloseModal */3);
                                                          }))
                                                  });
                                      } else {
                                        return Curry._1(toggleTab, (function (param) {
                                                      return /* PendingPriorities */1;
                                                    }));
                                      }
                                    })
                                }, "Pending Priorities")),
                        className: "c-core-pricing-toggle-btn"
                      }), React.createElement("div", undefined, tmp$1)), React.createElement(ManagePriorityFooter.make, {
                    formDirty: allowedUserAction !== 0,
                    user_role: user_role,
                    createCampaignHandler: (function (param) {
                        return Curry._1(dispatch, {
                                    TAG: /* UpdateSidebarState */6,
                                    opened_sidebar: /* CreateZonalOrClusterCampaign */2
                                  });
                      }),
                    resetClickHandler: (function (param) {
                        return Curry._1(updateUserAction, (function (param) {
                                      return /* All */0;
                                    }));
                      }),
                    submitClickHandler: (function (param) {
                        var payload = UpdateZoneClusterPayloadGenerator.generatePayoad(allowedUserAction, newPriority, changedStatus, activeTab);
                        if (payload === undefined) {
                          return ;
                        }
                        var warningModal = allowedUserAction >= 2 ? AllocationDashboardUtils.Modals.getWarningBeforeSubmissionOnStatusChange : AllocationDashboardUtils.Modals.getWarningBeforeSubmissionOnPriorityChange;
                        return Curry._1(dispatch, {
                                    TAG: /* OpenModal */10,
                                    modal: Curry._2(warningModal, (function (param) {
                                            return Curry._1(dispatch, /* CloseModal */3);
                                          }), (function (param) {
                                            Curry._1(setRequestStatus, (function (param) {
                                                    return {
                                                            TAG: /* Loading */0,
                                                            _0: undefined
                                                          };
                                                  }));
                                            AllocationDashboardDataMachine.updateZoneClusterCampaigns(payload, (function (response) {
                                                    var match = user_role.access_level;
                                                    if (match !== 1) {
                                                      if (match !== 0) {
                                                        
                                                      } else {
                                                        Curry._1(dispatch, {
                                                              TAG: /* OpenSnackbar */7,
                                                              snackbar_message: {
                                                                TAG: /* Success */0,
                                                                _0: "Campaigns Updated Successfully"
                                                              }
                                                            });
                                                      }
                                                    } else {
                                                      switch (allowedUserAction) {
                                                        case /* All */0 :
                                                            break;
                                                        case /* ChangePriority */1 :
                                                            Curry._1(dispatch, {
                                                                  TAG: /* OpenSnackbar */7,
                                                                  snackbar_message: {
                                                                    TAG: /* Success */0,
                                                                    _0: "New Priorities have been assigned and sent for approval"
                                                                  }
                                                                });
                                                            break;
                                                        case /* ChangeStatus */2 :
                                                            Curry._1(dispatch, {
                                                                  TAG: /* OpenSnackbar */7,
                                                                  snackbar_message: {
                                                                    TAG: /* Success */0,
                                                                    _0: "Campaigns Updated Successfully"
                                                                  }
                                                                });
                                                            break;
                                                        
                                                      }
                                                    }
                                                    Curry._1(setRequestStatus, (function (param) {
                                                            return {
                                                                    TAG: /* Live */1,
                                                                    _0: response
                                                                  };
                                                          }));
                                                    Curry._1(updateUserAction, (function (param) {
                                                            return /* All */0;
                                                          }));
                                                    return Curry._1(dispatch, {
                                                                TAG: /* SetZoneClusterCamapigns */13,
                                                                zoneClusterCampaigns: /* Init */0
                                                              });
                                                  }), (function (error) {
                                                    Curry._1(setRequestStatus, (function (param) {
                                                            return {
                                                                    TAG: /* Error */2,
                                                                    _0: error
                                                                  };
                                                          }));
                                                    return Curry._1(dispatch, {
                                                                TAG: /* OpenSnackbar */7,
                                                                snackbar_message: {
                                                                  TAG: /* Error */1,
                                                                  _0: ErrorUtils$Catalyst.resolveError(error)
                                                                }
                                                              });
                                                  }), country);
                                            return Curry._1(dispatch, /* CloseModal */3);
                                          }))
                                  });
                      })
                  }));
          break;
      case /* Error */2 :
          tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: zone_cluster_campaigns_list._0
              });
          break;
      
    }
  }
  var tmp$2;
  var tmp$3 = match$5[0];
  tmp$2 = typeof tmp$3 === "number" || tmp$3.TAG !== /* Loading */0 ? null : React.createElement(ProgressModal.make, {
          isOpen: true
        });
  return React.createElement("div", undefined, React.createElement(SidebarHeaderCmp.make, {
                  preview: true,
                  campaign_name: "Manage Priorities",
                  discard_warning_required: allowedUserAction !== /* All */0,
                  dispatch: dispatch
                }), tmp, React.createElement(React.Fragment, undefined, tmp$2));
}

var make = ManagePrioritiesContainer;

export {
  showWarningModal ,
  filterItems ,
  getSelectedItem ,
  getFilteredCampaigns ,
  getCampaignCountByStatusForSelectedFilter ,
  getApprovedPriorities ,
  make ,
  
}
/* react Not a pure module */
